import React, { useState, useEffect } from "react";
import { Button, DatePicker, Input } from "antd";
import { useNavigate, useParams } from "react-router-dom";
import {
  ErrorToast,
  ShowInputError,
  SuccessToast,
} from "../../../../widgets/AppToast";
import TextArea from "antd/es/input/TextArea";
import { post } from "../../../../services/services";
import { ApiURL } from "../../../../services/apiConstants";
import useUserData from "../../../../hooks/useUserData";
import { addEntry } from "../../../../services/indexedDBService";
import dayjs from "dayjs";
import { useDate } from "../../../../context/DateContext";
import { convertUTCToLocalDatetimeLocal } from "../../../../utils/dateFormatter";
import AppInput from "../../../../components/AppInput";

const BasicEngineLog = () => {
  const { eng_log_basic_id } = useParams();
  const { setSelectedDate } = useDate();
  const user = useUserData();
  const navigate = useNavigate();
  const [loader, set_loader] = useState(false);
  const [errors, set_errors] = useState({});
  const [staff_dashboard, set_staff_dashboard] = useState([]);
  const [sea_water_temp, set_sea_water_temp] = useState("");
  const [ambient_temp, set_ambient_temp] = useState("");
  const [engine_room_temp, set_engine_room_temp] = useState("");
  const [engine_room_barometric_press, set_engine_room_barometric_press] =
    useState("");
  const [free_Text, set_Free_Text] = useState("");
  const [update_status, set_update_status] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(false);
  const [logDate, set_LogDate] = useState(null);
  const [previous_log_date, set_Previous_Log_Date] = useState("");

  const GET_PREVIUS_LOG_DATE = () => {
    const FORM_DATA = new FormData();
    post(ApiURL.basic_previous_date_st, FORM_DATA).then((res) => {
      if (res?.status === true) {
        const previusDate = res?.previous_date_time_log;
        set_Previous_Log_Date(previusDate);
      }
    });
  };

  // useEffect(() => {
  //   const total =
  //     parseInt(main_engine_fuel_consumption) +
  //     parseInt(auxiliary_engine_fuel_consumption) +
  //     parseInt(boiler_fuel_consumption);
  //   localStorage.setItem("totalcount", total);
  // }, [main_engine_fuel_consumption]);

  // const ADD_BASIC_DETAILS_LOGBOOK_API = async() => {
  //   set_loader(true);
  //   if (navigator.onLine) {
  //      try {
  //     const FORM_DATA = new FormData();
  //     FORM_DATA.append("voyage_id", Number(staff_dashboard?.voyage_details?.[0]?.id) || 0);
  //     FORM_DATA.append("date_time_log", logDate || "");
  //     FORM_DATA.append("rpm_counter", Number(rpm_counter) || 0);
  //     FORM_DATA.append("rpm", Number(rpm) || 0);
  //     FORM_DATA.append("hours_on_full_load", Number(hours_on_full_load) || 0);
  //     FORM_DATA.append("load_setting_ecr", Number(load_setting_ecr) || 0);
  //     FORM_DATA.append("entry_zone", zone || "");
  //     FORM_DATA.append("sea_water_temp", Number(sea_water_temp) || 0);
  //     FORM_DATA.append("ambient_temp", Number(ambient_temp) || 0);
  //     FORM_DATA.append("engine_room_temp", Number(engine_room_temp) || 0);
  //     FORM_DATA.append("engine_room_barometric_press", Number(engine_room_barometric_press) || 0);
  //     FORM_DATA.append("speed", Number(speed) || 0);
  //     FORM_DATA.append("distance", Number(distance) || 0);
  //     FORM_DATA.append("slip", Number(slip) || 0);
  //     FORM_DATA.append("main_engine_fuel_consumption", Number(main_engine_fuel_consumption) || 0);
  //     FORM_DATA.append(
  //       "auxiliary_engine_fuel_consumption",
  //       Number(auxiliary_engine_fuel_consumption) || 0
  //     );
  //     FORM_DATA.append("boiler_fuel_consumption", Number(boiler_fuel_consumption) || 0);
  //     FORM_DATA.append("cylinder_oil_consumption", Number(cylinder_oil_consumption) || 0);
  //     FORM_DATA.append("other_fuel_consuption", Number(other_fuel_Consumption) || 0);
  //     FORM_DATA.append("main_engine_fuel_in", Number(main_engine_fuel_in) || 0);
  //     FORM_DATA.append("main_engine_fuel_out", Number(main_engine_fuel_out) || 0);
  //     FORM_DATA.append("auxiliary_engine_fuel_in", Number(auxiliary_engine_fuel_in) || 0);
  //     FORM_DATA.append("auxiliary_engine_fuel_out", Number(auxiliary_engine_fuel_out) || 0);
  //     FORM_DATA.append("main_fuel_Oil_Type", main_fuel_Oil_Type);
  //     FORM_DATA.append("main_other_fuel_oil_type", main_other_fuel_oil_type);
  //     FORM_DATA.append("auxi_fuel_Oil_Type", auxi_fuel_Oil_Type);
  //     FORM_DATA.append("auxi_other_fuel_oil_type", auxi_other_fuel_oil_type);
  //     FORM_DATA.append("boiler_fuel_Oil_Type", boiler_fuel_Oil_Type);
  //     FORM_DATA.append("boiler_other_fuel_oil_type", boiler_other_fuel_oil_type);
  //     FORM_DATA.append("boiler_fuel_in", Number(boiler_fuel_in) || 0);
  //     FORM_DATA.append("boiler_fuel_out", Number(boiler_fuel_out) || 0);
  //     FORM_DATA.append("basic_comment", free_Text || "");

  //     post(ApiURL.add_eng_log_basic_st, FORM_DATA).then((res) => {
  //       const eng_log_basic_id = res?.eng_log_data?.id;
  //       if (res?.status == true) {
  //         SuccessToast("Success message!", res?.message);
  //         set_loader(false);
  //         navigate("/edit-engine-basic-info/" + eng_log_basic_id);
  //       } else {
  //         set_loader(false);
  //         ErrorToast("Error message", res?.error);
  //         const errors = res?.errors || {};
  //         set_errors(errors);
  //       }
  //     });
  //   } catch (error) {
  //     console.error("Error adding Details logbook:", error);
  //   } finally {
  //   }
  //   }else{
  //      await addEntry({
  //       timestamp: Date.now(),
  //       // logData: logData,
  //     });
  //   }

  // };

  const ADD_BASIC_DETAILS_LOGBOOK_API = async () => {
    set_loader(true);
    const logData = {
      voyage_id: Number(staff_dashboard?.voyage_details?.[0]?.id) || 0,
      date_time_log: logDate || "",
      sea_water_temp: Number(sea_water_temp) || 0,
      ambient_temp: Number(ambient_temp) || 0,
      engine_room_temp: Number(engine_room_temp) || 0,
      engine_room_barometric_press: Number(engine_room_barometric_press) || 0,
      basic_comment: free_Text || "",
      timestamp: Date.now(),
      sync_pending: true,
      main_eng_log: "Pending",
      aux_eng_log: "Pending",
      eng_log_basic: "Pending",
      auxi_machinary_log: "Pending",
      cargo_machinary_log: "Pending",
    };

    if (navigator.onLine) {
      try {
        const FORM_DATA = new FormData();
        Object.entries(logData).forEach(([key, value]) => {
          if (key !== "timestamp") {
            FORM_DATA.append(key, value);
          }
        });
        const res = await post(ApiURL.add_eng_log_basic_st, FORM_DATA);
        const eng_log_basic_id = res?.eng_log_data?.id;

        if (res?.status === true) {
          SuccessToast("Success message!", res?.message);
          navigate("/edit-engine-basic-info/" + eng_log_basic_id);
        } else {
          ErrorToast("Error message", res?.error);
          set_errors(res?.errors || {});
        }
      } catch (error) {
        console.error("Error adding log online:", error);
      } finally {
        set_loader(false);
      }
    } else {
      try {
        await addEntry(logData);
        SuccessToast(
          "Saved Offline",
          "Data saved offline and will sync when online."
        );
      } catch (err) {
        console.error("Failed to save offline:", err);
        ErrorToast("Offline Error", "Failed to save data offline.");
      } finally {
        set_loader(false);
      }
    }
  };

  const UPDATE_BASIC_DETAILS_LOGBOOK_API = (save_submit) => {
    set_loader(true);
    try {
      const FORM_DATA = new FormData();
      FORM_DATA.append(
        "voyage_id",
        Number(staff_dashboard?.voyage_details?.[0]?.id) || 0
      );
      FORM_DATA.append("date_time_log", logDate || "");
      FORM_DATA.append("save_submit", Number(save_submit) || 0);
      FORM_DATA.append("eng_log_basic_id", Number(eng_log_basic_id) || 0);

      FORM_DATA.append("sea_water_temp", Number(sea_water_temp) || 0);
      FORM_DATA.append("ambient_temp", Number(ambient_temp) || 0);
      FORM_DATA.append("engine_room_temp", Number(engine_room_temp) || 0);
      FORM_DATA.append(
        "engine_room_barometric_press",
        Number(engine_room_barometric_press) || 0
      );
      FORM_DATA.append("basic_comment", free_Text || "");
      post(ApiURL.view_update_eng_log_basic_st, FORM_DATA).then((res) => {
        const eng_log_basic_id = res?.eng_log_data?.id;
        if (res?.status == true) {
          SuccessToast("Logbook Update Success!", res?.message);
          set_loader(false);
          if (eng_log_basic_id) VIEW_BASIC_DETAILS_LOGBOOK_API(staff_dashboard);
        } else {
          set_loader(false);
          set_errors(res?.errors);
          ErrorToast(
            "Error message",
            "Submission failed! Please fill in all required fields and try again."
          );
        }
      });
    } catch (error) {
      console.error("Error updating logbook:", error);
    } finally {
    }
  };

  const VIEW_BASIC_DETAILS_LOGBOOK_API = (voyage_id) => {
    try {
      const FORM_DATA = new FormData();
      FORM_DATA.append("voyage_id", voyage_id?.voyage_details[0]?.id);
      FORM_DATA.append("eng_log_basic_id", eng_log_basic_id);
      post(ApiURL.view_update_eng_log_basic_st, FORM_DATA).then((res) => {
        if (res?.status == true) {
          const Logbook = res?.eng_log_data;
          set_update_status(Logbook?.complete_status);
          set_sea_water_temp(Logbook?.sea_water_temp);
          set_ambient_temp(Logbook?.ambient_temp);
          set_engine_room_temp(Logbook?.engine_room_temp);
          set_engine_room_barometric_press(
            Logbook?.engine_room_barometric_press
          );
          set_Free_Text(Logbook?.basic_comment);
          setSubmitStatus(res?.submit_status);
          set_LogDate(Logbook?.date_time_log);
          setSelectedDate(Logbook?.date_time_log);
        }
      });
    } catch (error) {
      console.error("Error View logbook:", error);
    }
  };

  useEffect(() => {
    const staff_dashboards = localStorage.getItem("staff_dashboard");
    const parsedData = JSON.parse(staff_dashboards);
    set_staff_dashboard(parsedData);
    if (parsedData && eng_log_basic_id) {
      VIEW_BASIC_DETAILS_LOGBOOK_API(parsedData);
    }
    GET_PREVIUS_LOG_DATE();
  }, []);

  const onChangeDateTime = (value) => {
    if (value) {
      set_LogDate(value.format("YYYY-MM-DD HH:mm:ss"));
      // setSelectedDate(value.format("YYYY-MM-DD HH:mm:ss"));
    } else {
      set_LogDate(null);
    }
  };

  return (
    <>
      <div className="white-container">
        <div
          className="theme-content-left-head"
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <h3 style={{ margin: 0 }}>Basic Information</h3>
        </div>
        <div className="row">
          <div className="col-6">
            <div className="input-box">
              <label>Date & Time</label>

              <DatePicker
                showTime
                format="YYYY-MM-DD HH:mm:ss"
                placeholder="Select Date & Time"
                value={logDate ? dayjs(logDate, "YYYY-MM-DD HH:mm:ss") : null}
                onChange={onChangeDateTime}
                style={{ width: "100%" }}
                disabledDate={(current) => {
                  if (!current) return false;
                  const prevDate = dayjs(
                    previous_log_date,
                    "YYYY-MM-DD HH:mm:ss"
                  );
                  const today = dayjs().endOf("day");
                  return (
                    current.isBefore(prevDate.startOf("day")) ||
                    current.isAfter(today)
                  );
                }}
              />

              {errors.date_time_log && (
                <ShowInputError errorMessage={errors.date_time_log} />
              )}
            </div>
          </div>
        </div>

        <div className="row">
          {/* Sea water Temp  */}
          <div className="col-6">
            <div className="input-box">
              <label>Sea water Temp (°C)</label>
              <Input
                disabled={submitStatus}
                value={sea_water_temp}
                placeholder="Sea water temp (°C)"
                onChange={(e) => set_sea_water_temp(e.target.value)}
              />
              {errors.sea_water_temp && (
                <ShowInputError errorMessage={errors.sea_water_temp} />
              )}
            </div>
          </div>
          {/* Ambient Temp*/}
          <div className="col-6">
            <div className="input-box">
              <label>Ambient Temp (°C)</label>
              <Input
                disabled={submitStatus}
                value={ambient_temp}
                placeholder="ambient temp"
                onChange={(e) => {
                  set_ambient_temp(e.target.value);
                }}
              />
              {errors.ambient_temp && (
                <ShowInputError errorMessage={errors.ambient_temp} />
              )}
            </div>
          </div>
        </div>

        <div className="row">
          {/* Engine Room Temp  */}
          <div className="col-6">
            <div className="input-box">
              <label>Engine Room Temp (°C)</label>
              <Input
                disabled={submitStatus}
                value={engine_room_temp}
                placeholder="Engine room temp (°C)"
                onChange={(e) => set_engine_room_temp(e.target.value)}
              />
              {errors.engine_room_temp && (
                <ShowInputError errorMessage={errors.engine_room_temp} />
              )}
            </div>
          </div>
          {/* Engine Room Barometric Press*/}
          <div className="col-6">
            <div className="input-box">
              <label>Engine Room Barometric Press (Bar)</label>
              <Input
                disabled={submitStatus}
                value={engine_room_barometric_press}
                placeholder="engine room barometric press (Bar)"
                onChange={(e) => {
                  set_engine_room_barometric_press(e.target.value);
                }}
              />
              {errors.engine_room_barometric_press && (
                <ShowInputError
                  errorMessage={errors.engine_room_barometric_press}
                />
              )}
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-6">
            <div className="input-box">
              <label>Basic Engine Comments</label>
              <TextArea
                rows={6}
                placeholder="Basic Engine Comments"
                maxLength={1000}
                disabled={submitStatus}
                value={free_Text}
                onChange={(e) => set_Free_Text(e.target.value)}
              />
              {errors.basic_comment && (
                <ShowInputError errorMessage={errors.basic_comment} />
              )}
            </div>
          </div>
        </div>

        <div className="row">
          {user?.data?.designation === "Chief Engineer" && eng_log_basic_id && (
            <div className="input-box" style={{ marginTop: "15px" }}>
              <Button
                disabled={submitStatus}
                loading={loader}
                className="save_btn"
                style={{ color: "white" }}
                onClick={
                  update_status
                    ? () => UPDATE_BASIC_DETAILS_LOGBOOK_API("1")
                    : () => ADD_BASIC_DETAILS_LOGBOOK_API()
                }
              >
                Submit
              </Button>
            </div>
          )}

          <div className="input-box" style={{ marginTop: "15px" }}>
            <Button
              disabled={submitStatus}
              loading={loader}
              className="save_btn"
              style={{ color: "white", marginLeft: "10px" }}
              onClick={
                update_status
                  ? () => UPDATE_BASIC_DETAILS_LOGBOOK_API("0")
                  : () => ADD_BASIC_DETAILS_LOGBOOK_API()
              }
            >
              Save
            </Button>
          </div>
        </div>
      </div>
    </>
  );
};

export default BasicEngineLog;
